module.exports = __webpack_public_path__ + "assets/img/473039fce6b248456c4084a30207e0be.svg";